export class Position {
    id: number = 0;
    positionNum!: string;
    description!: string;
    active: boolean = false;   
    parentPositionNum!: string;
    baseSalary: number = 0;
    level: number = 0;
    positionPay: number = 0;
}